import { render, staticRenderFns } from "./EstimateTaskItemComponent.vue?vue&type=template&id=68b70c95&"
import script from "./EstimateTaskItemComponent.vue?vue&type=script&lang=js&"
export * from "./EstimateTaskItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports